// Реальные цвета бренда Сушисет (дизайн-спека §2.5)
export const ZONE_COLORS = { green: '#56db40', yellow: '#ffd21e', red: '#ed4543' }
export const ZONE_SETTINGS_COLORS = {
  green: '#4CAF50',
  yellow: '#ffd21e',
  red: '#ed4543',
}
export const ZONE_NAMES = { green: 'Зелёная', yellow: 'Жёлтая', red: 'Красная' }
export const ZONE_ORDER = ['green', 'yellow', 'red']

// Цвета интерфейса (дизайн-спека §2.6)
export const BRAND = '#ff9100'
export const BRAND_RING = 'rgba(255,145,1,.26)'

// Время доставки — фикс. список, кратно 15 (дизайн-спека §2.4)
export const TIME_OPTIONS = (() => {
  const a = []
  for (let m = 15; m <= 180; m += 15) a.push(m)
  return a
})()

// Тексты контекстной подсказки (дизайн-спека §4)
export const HINTS = {
  drawing:
    'Кликайте по карте, чтобы поставить точки зоны. Замкните контур по первой точке — откроется сохранение.',
  all: 'Это общая карта сети — показаны зоны всех филиалов. Выберите филиал, чтобы рисовать и настраивать его зоны.',
  green:
    'Зелёная зона — ближняя, самое быстрое время доставки. Соседние филиалы видны на карте — только для просмотра.',
  yellow:
    'Жёлтая зона — средний радиус доставки. Соседние филиалы видны на карте — только для просмотра.',
  red: 'Красная зона — дальняя, самое долгое время доставки. Соседние филиалы видны на карте — только для просмотра.',
}
